import { OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

import { Log } from '../../utils/index';
import { SimpleCrudInterface } from '../../services/crud.interface';

declare var jQuery: any;

export class SimpleCrudComponent implements OnInit {
  items: any[] = [];
  total: number;
  entityForm: any;

  constructor(protected service: SimpleCrudInterface<any>,
              protected entity: any,
              protected notification: NotificationsService) {
    this.entityForm = new entity();
  }

  @Log()
  ngOnInit() {
    this.getAll();
  }

  getAll(force: boolean = false) {
    this.service.getAll(force).then((items: any[]) => {
      this.items = items;
      this.total = items.length;
    });
  }

  @Log('blue')
  add() {
    this.entityForm = new this.entity();
    jQuery('.form-modal').modal();
  }

  @Log('blue')
  edit(entity: any) {
    this.entityForm = entity;
    jQuery('.form-modal').modal();
  }

  @Log('blue')
  save() {
    this.service.save(this.entityForm).subscribe((res: any) => {
      jQuery('.form-modal').modal('hide');
      this.getAll(true);
      this.notification.success('SUCCESS', 'Entity saved successfully');
    });
  }

  @Log('blue')
  remove(event: Event, entity: any) {
    event.stopPropagation();
    if (confirm('Are you sure you want to remove this item ?')) {
      this.service.remove(entity).subscribe((res: any) => {
        this.getAll(true);
        this.notification.success('SUCCESS', 'Entity removed successfully');
      });
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/simple-crud.component.ts